import {
    Typography, Box, Paper, Grid, TableContainer, TableHead, TableRow,
    TableCell, TableBody, Table, IconButton, Tooltip,
    Dialog, DialogTitle, DialogContent,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { FaCheckCircle, FaRegTimesCircle, FaPlus, FaMinus } from "react-icons/fa";
import { FaPrint } from "react-icons/fa6";
import { MdSubdirectoryArrowRight, MdClose } from "react-icons/md";
import { NumericFormat } from "react-number-format";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatNumber } from "../../widgets/FormatNumber";
import { getData } from "../../api/ApiRest";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";

// ── Estilos ───────────────────────────────────────────────────────────────────

const HeaderCell = styled(TableCell)(() => ({
    backgroundColor: '#224B6A',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '0.78rem',
    whiteSpace: 'nowrap',
    padding: '10px 12px',
}));

const BodyCell = styled(TableCell)(() => ({
    fontSize: '0.78rem',
    padding: '7px 12px',
    borderColor: '#dee2e6',
}));

const StyledRow = styled(TableRow)(({ index }) => ({
    backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc',
    '&:hover': { backgroundColor: 'rgba(144, 203, 216, 0.2)' },
}));

const SubHeaderCell = styled(TableCell)(() => ({
    backgroundColor: 'rgba(144,203,216,0.5)',
    color: '#224B6A',
    fontWeight: 'bold',
    fontSize: '0.78rem',
    whiteSpace: 'nowrap',
    padding: '8px 12px',
}));

// ── Componente ────────────────────────────────────────────────────────────────

export default function HistoricoPlanes({ PlanesActuales, openAlertObservation, openDetalleFoliosFunc }) {
    const [resultDataArray, setResultDataArray] = useState([]);
    const [resultStateActive, setResultStateActive] = useState({});
    const [facturasPlan, setFacturasPlan] = useState({ ModalVisible: false, Id: '' });
    const [documentos, setDocumentos] = useState([]);
    const [recibos, setRecibos] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [frame, setFrame] = useState({ ModalVisible: false, Token: '', Documento: '' });

    useEffect(() => {
        const planesPadre = PlanesActuales.filter((p) => p.esPadre);
        const planesHijos = PlanesActuales.filter((p) => !p.esPadre);
        const result = planesPadre.map((padre) => {
            const hijos = planesHijos
                .filter((hijo) => hijo.planPadreId === padre.id)
                .sort((a, b) => new Date(a.fechaInicio) - new Date(b.fechaInicio));
            return { ...padre, hijos, mostrarHijos: false };
        });
        setResultDataArray(result);
        setResultStateActive(PlanesActuales.filter(item => item.estado === true)[0]);
    }, [PlanesActuales]);

    const toggleMostrarHijos = (id) => {
        setResultDataArray((prev) => prev.map((p) => p.id === id ? { ...p, mostrarHijos: !p.mostrarHijos } : p));
    };

    const toggleMostrarRecibos = (id) => {
        setExpandedRows((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    const visualizarFacturas = (id) => {
        getData('api/Configuracion/Company/GetFacturasPlan', { Id: id }).then(
            response => setDocumentos(response.facturas),
            error => console.log(error)
        );
    };

    const visualizarDocumentos = (companyplanid) => {
        getData('api/Configuracion/Company/GetDocumentosPlan', { companyplanid }).then(
            response => setRecibos(response.documentos),
            error => console.log(error)
        );
    };

    const visualizarRecibo = (Documento, Token) => {
        setFrame({ ModalVisible: true, Documento, Token });
    };

    const renderFila = (item, index, esHijo = false) => {
        const pct = item.planId === 23
            ? (item.foliosConsumidos / item.foliosCustom) * 100
            : (item.foliosConsumidos / item.foliosAnual) * 100;
        const folios = item.planId === 23 ? item.foliosCustom : item.foliosAnual;

        return (
            <StyledRow key={item.id} index={index}
                sx={item.reserva ? { backgroundColor: 'lightyellow !important' } : {}}>
                <BodyCell sx={{ width: 40 }}>
                    {esHijo ? (
                        <MdSubdirectoryArrowRight size={18} color="#64748b" />
                    ) : item.hijos?.length ? (
                        <Tooltip title={item.mostrarHijos ? 'Ocultar renovaciones' : 'Ver renovaciones'}>
                            <IconButton size="small"
                                onClick={() => toggleMostrarHijos(item.id)}
                                sx={{ color: '#224B6A', border: '1px solid #b0c4d8', borderRadius: 1, p: 0.3 }}>
                                {item.mostrarHijos ? <FaMinus size={10} /> : <FaPlus size={10} />}
                            </IconButton>
                        </Tooltip>
                    ) : null}
                </BodyCell>
                <BodyCell align="center">{item.id}</BodyCell>
                <BodyCell align="center">
                    <Link onClick={() => openDetalleFoliosFunc(item)}
                        style={{ color: '#224B6A', fontSize: '0.78rem' }}>
                        {item.plan}
                    </Link>
                </BodyCell>
                <BodyCell align="center">
                    <NumericFormat displayType="text" thousandSeparator="," value={folios} />
                </BodyCell>
                <BodyCell align="center">
                    <NumericFormat displayType="text" thousandSeparator="," value={item.foliosConsumidos} />
                </BodyCell>
                <BodyCell align="center">
                    <NumericFormat displayType="text" thousandSeparator="," decimalScale={2} value={pct} />%
                </BodyCell>
                <BodyCell align="center">{moment(item.fechaInicio).format("DD-MMM-YYYY")}</BodyCell>
                <BodyCell align="center">{moment(item.fechaFin).format("DD-MMM-YYYY")}</BodyCell>
                <BodyCell align="center">
                    $<NumericFormat displayType="text" thousandSeparator="," value={item.valorAnual} />
                </BodyCell>
                <BodyCell align="center">{item.pagoAnual ? "Anual" : "Mensual"}</BodyCell>
                <BodyCell align="center">
                    {item.estado
                        ? <FaCheckCircle size={15} color="#16a34a" />
                        : <FaRegTimesCircle size={15} color="#dc2626" />}
                </BodyCell>
                <BodyCell align="center">
                    <Typography
                        onClick={() => {
                            visualizarFacturas(item.id);
                            visualizarDocumentos(item.id);
                            setFacturasPlan({ ModalVisible: true, Id: item.id });
                        }}
                        sx={{ fontSize: '0.78rem', cursor: 'pointer', textDecoration: 'underline', color: '#224B6A' }}>
                        <NumericFormat displayType="text" thousandSeparator="," value={item.cantidadFacturas} />
                    </Typography>
                </BodyCell>
            </StyledRow>
        );
    };

    return (
        <Box sx={{ mt: 3 }}>

            {/* Resumen folios plan activo */}
            {resultStateActive && (
                <Grid container spacing={1.5} sx={{ mb: 2 }}>
                    {[
                        { label: 'Total folios', value: formatNumber(resultStateActive.foliosAnual) },
                        { label: 'Total emitidos', value: formatNumber(resultStateActive.foliosConsumidos) },
                        { label: 'Folios disponibles', value: formatNumber(resultStateActive.foliosAnual - resultStateActive.foliosConsumidos) },
                    ].map((stat, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ px: 2, py: 1.2, bgcolor: 'rgba(144,203,216,0.35)', flex: 1 }}>
                                        <Typography fontSize="0.78rem" fontWeight={700} color="#224B6A">
                                            {stat.label}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ px: 2, py: 1.2 }}>
                                        <Typography fontSize="0.82rem" fontWeight={700} color="#224B6A">
                                            {stat.value}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            )}

            {/* Tabla histórico */}
            <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <HeaderCell colSpan={12} align="center" sx={{ fontSize: '0.9rem', py: 1.2 }}>
                                Histórico de planes
                            </HeaderCell>
                        </TableRow>
                        <TableRow>
                            <SubHeaderCell />
                            <SubHeaderCell align="center">Id</SubHeaderCell>
                            <SubHeaderCell align="center">Plan</SubHeaderCell>
                            <SubHeaderCell align="center">Folios</SubHeaderCell>
                            <SubHeaderCell align="center">Folios Consumidos</SubHeaderCell>
                            <SubHeaderCell align="center">Plan Consumido</SubHeaderCell>
                            <SubHeaderCell align="center">Fecha Inicio</SubHeaderCell>
                            <SubHeaderCell align="center">Fecha Fin</SubHeaderCell>
                            <SubHeaderCell align="center">Valor Plan</SubHeaderCell>
                            <SubHeaderCell align="center">Tipo Pago</SubHeaderCell>
                            <SubHeaderCell align="center">Activo</SubHeaderCell>
                            <SubHeaderCell align="center">Facturas</SubHeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {resultDataArray.map((padre, i) => (
                            <Fragment key={padre.id}>
                                {renderFila(padre, i, false)}
                                {padre.mostrarHijos && padre.hijos.map((hijo, j) => (
                                    renderFila(hijo, j, true)
                                ))}
                            </Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Modal: Facturas del plan */}
            <Dialog open={facturasPlan.ModalVisible} maxWidth="lg" fullWidth
                onClose={() => { setFacturasPlan({ ModalVisible: false, Id: '' }); setDocumentos([]); }}>
                <DialogTitle sx={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    background: '#224B6A', color: '#fff', py: 1.5, px: 2,
                }}>
                    <Typography fontWeight={700} fontSize="0.95rem">
                        Facturas del plan #{facturasPlan.Id}
                    </Typography>
                    <IconButton size="small" sx={{ color: '#fff' }}
                        onClick={() => { setFacturasPlan({ ModalVisible: false, Id: '' }); setDocumentos([]); }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <HeaderCell />
                                    <HeaderCell align="center">Documento</HeaderCell>
                                    <HeaderCell align="center">Fecha</HeaderCell>
                                    <HeaderCell align="right">Total</HeaderCell>
                                    <HeaderCell align="right">Saldo</HeaderCell>
                                    <HeaderCell align="center">Recibos</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {documentos.map((item, index) => (
                                    <Fragment key={item.facturaid}>
                                        <StyledRow index={index}>
                                            <BodyCell sx={{ width: 40 }}>
                                                {item.documentos > 0 && (
                                                    <Tooltip title={expandedRows.includes(item.facturaid) ? 'Ocultar recibos' : 'Ver recibos'}>
                                                        <IconButton size="small"
                                                            onClick={() => toggleMostrarRecibos(item.facturaid)}
                                                            sx={{ color: '#224B6A', border: '1px solid #b0c4d8', borderRadius: 1, p: 0.3 }}>
                                                            {expandedRows.includes(item.facturaid) ? <FaMinus size={10} /> : <FaPlus size={10} />}
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </BodyCell>
                                            <BodyCell align="center">{item.prefijo} - {item.numero}</BodyCell>
                                            <BodyCell align="center">{formatDateddMMMyyyy(item.fecha)}</BodyCell>
                                            <BodyCell align="right">${formatNumber(item.total)}</BodyCell>
                                            <BodyCell align="right">${formatNumber(item.saldofv)}</BodyCell>
                                            <BodyCell align="center">{formatNumber(item.documentos)}</BodyCell>
                                        </StyledRow>
                                        {expandedRows.includes(item.facturaid) &&
                                            recibos.filter(x => x.facturaid === item.facturaid).map((doc) => (
                                                <TableRow key={doc.documentoid}
                                                    sx={{ backgroundColor: 'rgba(144,203,216,0.2)' }}>
                                                    <BodyCell sx={{ width: 40 }}>
                                                        <Tooltip title="Imprimir recibo">
                                                            <IconButton size="small" color="warning"
                                                                onClick={() => visualizarRecibo(doc.prefijo + ' - ' + doc.numero, doc.token)}>
                                                                <FaPrint size={12} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </BodyCell>
                                                    <BodyCell align="center">{doc.prefijo} - {doc.numero}</BodyCell>
                                                    <BodyCell align="center">{formatDateddMMMyyyy(doc.fecha)}</BodyCell>
                                                    <BodyCell align="right">${formatNumber(doc.valor)}</BodyCell>
                                                    <BodyCell colSpan={2} />
                                                </TableRow>
                                            ))}
                                    </Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>

            {/* Modal: Impresión recibo */}
            <Dialog open={frame.ModalVisible} maxWidth="md" fullWidth
                onClose={() => setFrame({ ModalVisible: false, Documento: '', Token: '' })}>
                <DialogTitle sx={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    background: '#224B6A', color: '#fff', py: 1.5, px: 2,
                }}>
                    <Typography fontWeight={700} fontSize="0.95rem">
                        Impresión {frame.Documento}
                    </Typography>
                    <IconButton size="small" sx={{ color: '#fff' }}
                        onClick={() => setFrame({ ModalVisible: false, Documento: '', Token: '' })}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 2 }}>
                    <iframe
                        src={"https://tae.goldpos.com.co/ReporteApp/Recibo/ImprimirReciboTaecol?documento=" + frame.Token}
                        width="100%"
                        height="450px"
                        style={{ border: '1px solid #e2e8f0', marginTop: 8 }}
                        title="Reporte PDF"
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
}
